module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.titulo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades\n\n        "), (!_vm.boqueia && !_vm.loading.tela) ? _c('span', [(((_vm.entidade.ds_status !== 'PENDENTE_APROVACAO') && (_vm.usuarioLogado.userType === 'ENTIDADE') || (_vm.usuarioLogado.userType === 'FUNDACAO'))) ? _c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "disabled": !_vm.isEditable()
    },
    nativeOn: {
      "click": function($event) {
        return _vm.permiteConcluir(_vm.frmCommonRegister)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), (((_vm.entidade.ds_status !== 'PENDENTE_APROVACAO') && (_vm.usuarioLogado.userType === 'ENTIDADE') || (_vm.usuarioLogado.userType === 'FUNDACAO'))) ? _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")]), _vm._v(" "), (_vm.entidade.ds_status === 'PENDENTE_APROVACAO' && _vm.usuarioLogado.userType === 'ENTIDADE' && _vm.propostaUnicaEditalVigente) ? _c('g-button-moema', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.devolverRevisao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Devolver Revisão")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Entidade    "), _c('a', {
    attrs: {
      "href": _vm.urlLaravel + '/docs/manual_cadastro_entidade_dirigentes_usuarios_v1.pdf',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manual")])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.boqueia === true
    }
  }, [_c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), (!_vm._.isEmpty(_vm._.get(_vm._.head(_vm.historico_atualizado), 'observacao', null)) && !_vm._.isNull(_vm._.get(_vm._.head(_vm.historico_atualizado), 'termino', null))) ? _c('div', {
    staticClass: "alert alert-dismissible alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm._.get(_vm._.head(_vm.historico_atualizado), 'observacao'))
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": !_vm.isEditable() || _vm.boqueia === true
    }
  }, [_c('legend', [_vm._v("\n                        Dados da entidade:\n\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Razão social"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome),
      expression: "entidade.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "text",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens,
      "disabled": "true"
    },
    model: {
      value: (_vm.entidade.ds_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
      },
      expression: "entidade.ds_cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpjExpeditionTime') || _vm.erroData == true
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cnpjExpeditionTime"
    }
  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data_expedicao_cnpj),
      expression: "data_expedicao_cnpj"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|date_format:dd/MM/yyyy|dateeqpast|after:01/01/1900'),
      expression: "'required|validdate|date_format:dd/MM/yyyy|dateeqpast|after:01/01/1900'"
    }],
    ref: "cnpjExpeditionTime",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cnpjExpeditionTime",
      "name": "cnpjExpeditionTime",
      "data-vv-as": "Expedição CNPJ",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.data_expedicao_cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data_expedicao_cnpj = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpjExpeditionTime')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome fantasia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome fantasia"
    }
  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome_fantasia),
      expression: "entidade.ds_nome_fantasia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Nome fantasia",
    staticClass: "form-control",
    attrs: {
      "name": "Nome fantasia",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome_fantasia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome_fantasia", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('forma_juridica')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "forma_jurídica"
    }
  }, [_vm._v(" Natureza jurídica: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaFormasJuridicas,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione uma Natureza Jurídica",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaListaFormaJuridica,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "forma_juridica",
      "data-vv-as": "Natureza jurídica"
    },
    model: {
      value: (_vm.entidade.forma_juridica),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "forma_juridica", $$v)
      },
      expression: "entidade.forma_juridica"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('forma_juridica')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma_juridica')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('ramos_atividade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Ramo atividade"
    }
  }, [_vm._v(" Ramos de Atividade: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listaRamosAtividade,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione os Ramos de Atividade",
      "label": "ds_codigo",
      "track-by": "ds_codigo",
      "custom-label": _vm.etiquetaListaRamosAtividade,
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "ramos_atividade",
      "data-vv-as": "Ramos de Atividade",
      "options-limit": 1500
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.entidade.ramos_atividade),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ramos_atividade", $$v)
      },
      expression: "entidade.ramos_atividade"
    }
  }, [_vm._v(" "), _c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('ramos_atividade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('ramos_atividade')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('listaDocConstituicao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "documento_constituicao"
    }
  }, [_vm._v(" Documento de constituição: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaDocConstituicao,
      "multiple": false,
      "close-on-select": true,
      "searchable": false,
      "track-by": "id",
      "label": "ds_tipo",
      "placeholder": "Selecione um Documento de constituição",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "listaDocConstituicao",
      "data-vv-as": "Documento de constituição"
    },
    model: {
      value: (_vm.entidade.documento_constituicao),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "documento_constituicao", $$v)
      },
      expression: "entidade.documento_constituicao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('listaDocConstituicao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('listaDocConstituicao')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-lg-6",
    attrs: {
      "id": "contato"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Telefone"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|max:11'),
      expression: "'required|min:10|max:11'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "data-vv-as": "Telefone",
      "type": "text",
      "masked": false,
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.entidade.contato.ds_telefone),
      callback: function($$v) {
        _vm.$set(_vm.entidade.contato, "ds_telefone", $$v)
      },
      expression: "entidade.contato.ds_telefone"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:10|max:11'),
      expression: "'min:10|max:11'"
    }],
    ref: "mobile",
    staticClass: "form-control",
    attrs: {
      "name": "mobile",
      "data-vv-as": "Celular",
      "type": "text",
      "masked": false,
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.entidade.contato.ds_celular),
      callback: function($$v) {
        _vm.$set(_vm.entidade.contato, "ds_celular", $$v)
      },
      expression: "entidade.contato.ds_celular"
    }
  }), _vm._v(" "), (_vm.errors.first('mobile')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('mobile')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_email),
      expression: "entidade.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "Email",
    staticClass: "form-control",
    attrs: {
      "name": "Email",
      "type": "text",
      "data-vv-as": "E-Mail",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.entidade.ds_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Email')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "website"
    }
  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_website),
      expression: "entidade.ds_website"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:255'),
      expression: "'max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "nam": "website",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.propostaUnicaEditalVigente) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCebas),
      expression: "possuiCebas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCebas"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeCebasCmas($event)
      }]
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]) : _vm._e(), _vm._v(" "), (!_vm.propostaUnicaEditalVigente) ? _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Possui CMAS/CAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCmas),
      expression: "possuiCmas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCmas"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onChangeCebasCmas($event)
      }]
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(1), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.entidade.endereco
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('dirigentes', {
    ref: "componenteDirigentes",
    attrs: {
      "entDirigentes": _vm.entidade.dirigentes,
      "entidadeParceira": _vm.entidade,
      "name": "dirigentes",
      "id": "dirigentes"
    },
    on: {
      "validacaoDirigente": function($event) {
        return _vm.adicionaRestricao($event)
      },
      "dirigenteAdicionado": function($event) {
        return _vm.verificarDirigenteAtivo($event)
      },
      "dirigenteSalvo": function($event) {
        return _vm.onDirigenteSalvo($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('assinaturaDirigentes', {
    attrs: {
      "visualiza": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('usuarios', {
    attrs: {
      "entUsuarios": _vm.entidade.usuarios
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "documentos"
    }
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.entidade.documentos,
      "documentTypes": _vm.entidade.tipos_documento,
      "localUso": _vm.listaDocEntidades,
      "salvouOK": _vm.salvouOK,
      "disable": _vm.entidade.ds_status === 'PENDENTE_APROVACAO' && _vm.usuarioLogado.userType === 'ENTIDADE' ? 'disable' : ''
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('historico-entidade', {
    attrs: {
      "entHistorico": _vm.historico
    },
    on: {
      "historico_itens": function($event) {
        _vm.historico_atualizado = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.entidade.resultadoAprovacao === 'Revisar') ? _c('div', {
    staticClass: "form-group full",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.observacao),
      expression: "entidade.observacao"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "observacao",
      "id": "observacao"
    },
    domProps: {
      "value": (_vm.entidade.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "observacao", $event.target.value)
      }
    }
  })]) : _vm._e()])])])])])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes/Designados:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Quem vai assinar o convênio com a Fundação BB (Conforme estatuto e/ou procuração)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuários do sistema:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos anexos:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb3141c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/entidade/EditaEntidades.vue
// module id = 2103
// module chunks = 1